import { render, staticRenderFns } from "./MessageDocument.vue?vue&type=template&id=3b46a14e&"
import script from "./MessageDocument.vue?vue&type=script&lang=ts&"
export * from "./MessageDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports